export const imageType = {
   'image/jpeg': ['.jpeg', '.jpg'],
   'image/png': ['.png'],
   'image/gif': ['.gif'],
};

export const availableExt = {
   'image/jpeg': ['.jpeg', '.jpg'],
   'image/png': ['.png'],
   'image/gif': ['.gif'],
   'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
      '.xlsx',
   ],
   'application/pdf': ['.pdf'],
};

export const extToLabel = (extensions: { [key: string]: string[] }) =>
   Object.values(extensions)
      .map((types) => types[0])
      .join(', ');

export const emojiList: string[] = [
   '😀',
   '😃',
   '😄',
   '😁',
   '😆',
   '😅',
   '😂',
   '🤣',
   '🥲',
   '😊',
   '😇',
   '🙂',
   '🙃',
   '😉',
   '😌',
   '😍',
   '🥰',
   '😘',
];

export const defaultStartRating: string[] = [
   'Horrible',
   'Médiocre',
   'Moyen',
   'Très bon',
   'Excellent',
];

export const doughnutBackgroundColor = [
   '#f87171',
   '#2dd4bf',
   '#fbbf24',
   '#818cf8',
   '#a3e635',
   '#38bdf8',
   '#c084fc',
   '#fb923c',
   '#22d3ee',
   '#4ade80',
   '#60a5fa',
   '#facc15',
   '#a78bfa',
   '#34d399',
   '#e879f9',
   '#0e7490',
   '#fb7185',
   '#b91c1c',
   '#15803d',
   '#be185d',
   '#0f766e',
   '#f472b6',
   '#7e22ce',
   '#1d4ed8',
   '#be123c',
   '#6d28d9',
   '#0369a1',
   '#a21caf',
   '#047857',
   '#4338ca',
];
